import { JiraTicketsParams } from '@services/formV2Admin/types';

export const formV2AdminKeys = {
  catalog: ['form-v2-catalog'] as const,
  catalogWithParams: (params: Record<string, unknown>) => [...formV2AdminKeys.catalog, params] as const,
  catalogDetail: (formId: string) => ['form-v2-catalog', formId] as const,
  simulate: ['form-v2-simulate'] as const,
  jiraTickets: ['form-v2-jira-tickets'] as const,
  jiraTicketsWithParams: (params: JiraTicketsParams) => [...formV2AdminKeys.jiraTickets, params] as const,
  packages: ['form-v2-packages'] as const,
  packageTypes: ['package-form-v2-package-types'] as const,
  packageForms: ['package-form-v2-package-forms'] as const,
  packageFormsWithParams: (params: Record<string, unknown>) => [...formV2AdminKeys.packageForms, params] as const,
  formNumbers: ['form-v2-form-numbers'] as const,
  formNumbersWithParams: (params: Record<string, unknown>) => [...formV2AdminKeys.formNumbers, params] as const,
  conflicts: ['form-v2-conflicts'] as const,
  conflictsWithParams: (params: Record<string, unknown>) => [...formV2AdminKeys.conflicts, params] as const,
};
